import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML para prevenir ataques XSS enquanto permite formatação básica
 * @param html - String HTML a ser sanitizada
 * @returns HTML limpo e seguro
 */
export const sanitizeHtml = (html: string): string => {
  // Hook customizado para validar estilos permitidos
  DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (data.attrName === 'style') {
      const value = data.attrValue;
      const allowedProps = [
        'color', 'font-size', 'text-align', 'background', 'background-color', 
        'background-image', 'background-clip', '-webkit-background-clip', 
        '-webkit-text-fill-color', 'display', 'border-color',
        'margin', 'margin-top', 'margin-bottom', 'margin-left', 'margin-right',
        'padding', 'padding-top', 'padding-bottom', 'padding-left', 'padding-right',
        'line-height', 'font-weight', 'list-style-type', 'list-style-position'
      ];
      // Parse styles carefully: split on ";" only when not inside parentheses
      const styles: string[] = [];
      let current = '';
      let depth = 0;
      for (const char of value) {
        if (char === '(') depth++;
        else if (char === ')') depth--;
        else if (char === ';' && depth === 0) {
          styles.push(current.trim());
          current = '';
          continue;
        }
        current += char;
      }
      if (current.trim()) styles.push(current.trim());

      const allowedStyles = styles
        .filter(style => {
          const colonIdx = style.indexOf(':');
          if (colonIdx === -1) return false;
          const prop = style.substring(0, colonIdx).trim();
          return allowedProps.includes(prop);
        })
        .join('; ');
      data.attrValue = allowedStyles;
    }
  });

  const result = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['strong', 'em', 'u', 's', 'a', 'br', 'code', 'pre', 'span', 'mark', 'sub', 'sup', 'h1', 'h2', 'h3', 'h4', 'p', 'ul', 'ol', 'li', 'blockquote', 'img', 'hr', 'div', 'cite'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'src', 'alt', 'data-type', 'data-text', 'data-href'],
    ALLOW_DATA_ATTR: false,
    KEEP_CONTENT: true,
  });

  // Remover o hook depois de usar
  DOMPurify.removeHook('uponSanitizeAttribute');

  return result;
};
